// Single source of truth for the primary navigation entries — shared by the
// desktop TopNav and the mobile BottomTabBar / "More" menu so the two never
// drift apart.
import { BarChart3, BookOpen, Bot, Cable, Calendar, Clock, FolderOpen, Users } from 'lucide-react';
import { Settings } from 'lucide-react';
import type { ComponentType, SVGProps } from 'react';
import { AgentMailLogo } from '@/components/AgentMailLogo';

export interface NavEntry {
  to: string;
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export const NAV: NavEntry[] = [
  { to: '/projects', label: 'Projects', icon: FolderOpen },
  { to: '/routines', label: 'Routines', icon: Clock },
  { to: '/calendar', label: 'Calendar', icon: Calendar },
  {
    to: '/email',
    label: 'Email',
    icon: AgentMailLogo as unknown as ComponentType<SVGProps<SVGSVGElement>>,
  },
  { to: '/contacts', label: 'Contacts', icon: Users },
  { to: '/agents', label: 'Agents', icon: Bot },
  { to: '/knowledge', label: 'Knowledge', icon: BookOpen },
  { to: '/analytics', label: 'Analytics', icon: BarChart3 },
  { to: '/connections', label: 'Connections', icon: Cable },
  { to: '/settings', label: 'Settings', icon: Settings },
];
